import api from 'services/Api';
import axios from 'axios';
import {production} from '../../configs/app';

export async function addSessionsEvent(type, referrer, custom) {
  await api.invoke('POST', '/core/v1/events/sessions', {
    type,
    referrer,
    custom,
  });
}

export async function postRegisterStatus(mobile, isRegistered) {
  let data = {
    totalpoll: {
      fields: {
        event: isRegistered ? 'ورود' : 'ثبت نام',
        mobile: mobile,
        market: 'web',
      },
      choices: {
        'ab92f29e-c72c-4608-a6ce-54d3061a55df': [
          '78b779b5-9aba-4702-b8d9-41106d8e66c6',
        ],
      },
    },
  };

  // try {
  //   if (production) {
  //     await axios.post(
  //       'https://marham.co/wp-json/totalpoll/v4/poll/571/vote',
  //       data,
  //     );
  //   }
  // } catch (error) {
  //   console.error(error);
  // }
}
